/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FixGringottsAccountHolderNameRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/FixGringottsAccountHolderName.pb'
import {FixGringottsAccountHolderNameResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/FixGringottsAccountHolderName.pb'


export const fixGringottsAccountHolderName = (request: FixGringottsAccountHolderNameRequest, options?: CashRequestOptions) => post<FixGringottsAccountHolderNameRequest, FixGringottsAccountHolderNameResponse>("/2.0/cash/fix-gringotts-account-holder-name", request, {...options, rejectOnError: true })